import { Modals } from 'presentation/libs/modals'

const MODAL_KEY = 'SelectFormatModal'

export const useSelectFormatModal = Modals.createHistoryUseModal(MODAL_KEY)
